'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2016/9/9.
                                          */

// import { Link } from 'react-router';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _orderDetail = require('redux/modules/orderDetail');

var orderDetailAction = _interopRequireWildcard(_orderDetail);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRouterRedux = require('react-router-redux');

var _background = require('redux/modules/background');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;
    var params = _ref.params;

    var promises = [];
    // console.log(JSON.stringify(location));
    /*
    const query = location.query;
    let page = null;
    if (query.page) {
      page = query.page;
    }
    console.log(orderDetailAction.isLoaded(getState())); */
    promises.push(dispatch((0, _background.changeHeaderText)('艺品订单详情')));
    promises.push(dispatch(orderDetailAction.load(params.orderId))); // page, orderDetailAction.isLoaded(getState())
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.orderDetail.data,
    submitData: state.orderDetail.submitData,
    cancelData: state.orderDetail.cancelData,
    detailData: state.orderDetail.detailData,
    modalProductId: state.orderDetail.modalProductId,
    detailModalOpened: state.orderDetail.detailModalOpened
  };
}, (0, _extends3.default)({}, orderDetailAction, {
  routerPush: _reactRouterRedux.push
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(OrderDetail, _Component);

  function OrderDetail() {
    (0, _classCallCheck3.default)(this, OrderDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OrderDetail).call(this));

    _this.state = {
      currentPage: 0
    };
    return _this;
  }

  (0, _createClass3.default)(OrderDetail, [{
    key: 'onDetailShow',
    value: function onDetailShow(productId) {
      var _props = this.props;
      var getDetail = _props.getDetail;
      var openDetailModal = _props.openDetailModal;
      var params = _props.params;

      if (getDetail) {
        getDetail(productId, params.orderId).then(function () {
          openDetailModal(productId);
        });
      }
    }
  }, {
    key: 'onDetailModalClose',
    value: function onDetailModalClose() {
      var closeDetailModal = this.props.closeDetailModal;

      if (closeDetailModal) {
        closeDetailModal();
      }
    }
  }, {
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      // console.log(page);
      /*
      const {routerPush, location} = this.props;
      if (routerPush) {
        routerPush({pathname: location.pathname, query: {page: page}});
      } */
      var _props2 = this.props;
      var load = _props2.load;
      var params = _props2.params;

      if (load) {
        this.setState({
          currentPage: page
        });
        load(params.orderId, page, true);
      }
    }
  }, {
    key: 'confirmReceipt',
    value: function confirmReceipt(orderId) {
      var _props3 = this.props;
      var onConfirmReceipt = _props3.onConfirmReceipt;
      var load = _props3.load;
      var params = _props3.params;

      if (onConfirmReceipt) {
        onConfirmReceipt(orderId).then(function (resultData) {
          if (resultData && resultData.confirmReceiptError === null) {
            load(params.orderId);
          }
        });
      }
    }
  }, {
    key: 'cancelOrder',
    value: function cancelOrder(orderId) {
      var _props4 = this.props;
      var onCancelOrder = _props4.onCancelOrder;
      var load = _props4.load;
      var params = _props4.params;

      if (onCancelOrder) {
        onCancelOrder(orderId).then(function (resultData) {
          // console.log(resultData);
          if (resultData && resultData.cancelOrderError === null) {
            load(params.orderId);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./OrderDetail.scss');
      var _props5 = this.props;
      var data = _props5.data;
      var submitData = _props5.submitData;
      var cancelData = _props5.cancelData;
      var params = _props5.params;
      var modalProductId = _props5.modalProductId;
      var detailData = _props5.detailData;
      var detailModalOpened = _props5.detailModalOpened;

      var errorLabel = '';
      if (submitData && submitData.confirmReceiptError) {
        errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: submitData.confirmReceiptError });
      } else if (cancelData && cancelData.cancelOrderError) {
        errorLabel = _react2.default.createElement(_components.ErrorLabel, { error: cancelData.cancelOrderError });
      }

      var orderDetailShow = '';
      var orderStatus = '';
      if (data) {
        var orderDetail = data.orderDetail;
        var orderLogisticsInformation = data.orderLogisticsInformation;
        var orderProductDetail = data.orderProductDetail;
        var orderDetailError = data.orderDetailError;
        var orderLogisticsInformationError = data.orderLogisticsInformationError;
        var orderProductDetailError = data.orderProductDetailError;
        var orderProductDetailRecordCount = data.orderProductDetailRecordCount;
        var orderProductDetailPagesize = data.orderProductDetailPagesize;

        if (orderDetailError || orderLogisticsInformationError || orderProductDetailError) {
          orderDetailShow = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.ErrorLabel, { error: 'orderDetailError: ' + orderDetailError }),
            _react2.default.createElement(_components.ErrorLabel, { error: 'orderLogisticsInformationError: ' + orderLogisticsInformationError }),
            _react2.default.createElement(_components.ErrorLabel, { error: 'orderProductDetailError: ' + orderProductDetailError })
          );
        } else if (orderDetail instanceof Array && orderDetail.length > 0) {
          orderStatus = '状态：' + orderDetail[0].status;
          // const {currentPage} = this.state;
          // let currentPageNumber = 0;
          var totalPageNumber = 1;
          if (orderProductDetail instanceof Array && orderDetail.length > 0) {
            /*
            if (location.query && !isNaN(parseInt(location.query.page, 10))) {
              currentPage = parseInt(location.query.page, 10);
            } */

            // currentPageNumber = parseInt(currentPage, 10);
            totalPageNumber = parseInt(orderProductDetailRecordCount / orderProductDetailPagesize, 10);
            if (orderProductDetailRecordCount % orderProductDetailPagesize > 0) {
              ++totalPageNumber;
            }
          }
          orderDetailShow = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { className: styles.xiodin,
                style: { paddingTop: '8px', float: 'right' } },
              orderDetail instanceof Array && orderDetail.length > 0 ? orderDetail[0].time : ''
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(_components.OrderDetailComponent, { orderDetail: orderDetail, confirmReceipt: this.confirmReceipt.bind(this),
              cancelOrder: this.cancelOrder.bind(this),
              orderLogisticsInformation: orderLogisticsInformation,
              onDetailShow: this.onDetailShow.bind(this),
              onDetailModalClose: this.onDetailModalClose.bind(this),
              onPageItemClick: this.onPageItemClick.bind(this)
              // currentPage={currentPageNumber}
              , totalPageNumber: totalPageNumber,
              detailData: detailData,
              detailModalOpened: detailModalOpened,
              modalProductId: modalProductId,
              orderProductDetail: orderProductDetail })
          );
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.xiocomponent },
        _react2.default.createElement(
          'div',
          { className: styles.xiodin },
          '订单编号：',
          params.orderId,
          _react2.default.createElement(
            'div',
            { className: styles.orderStatus },
            orderStatus
          )
        ),
        _react2.default.createElement('div', { className: styles.xiolb }),
        _react2.default.createElement('div', { className: styles.xiolc }),
        _react2.default.createElement('div', { className: styles.xiola }),
        _react2.default.createElement('div', { className: 'clear' }),
        orderDetailShow,
        errorLabel,
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return OrderDetail;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object,
  submitData: _react.PropTypes.object,
  cancelData: _react.PropTypes.object,
  location: _react.PropTypes.object,
  params: _react.PropTypes.object,
  load: _react.PropTypes.func,
  onCancelOrder: _react.PropTypes.func,
  onConfirmReceipt: _react.PropTypes.func,
  openDetailModal: _react.PropTypes.func,
  closeDetailModal: _react.PropTypes.func,
  routerPush: _react.PropTypes.func,
  getDetail: _react.PropTypes.func,
  detailModalOpened: _react.PropTypes.bool,
  modalProductId: _react.PropTypes.string,
  detailData: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = OrderDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/OrderDetail/OrderDetail.js
 ** module id = 1507
 ** module chunks = 0
 **/